/**
 * BaseTextarea - Foundational textarea component with styling
 *
 * This is a low-level component. Prefer using TextareaField.
 */

import { forwardRef } from 'react';

import { cn } from '../utils';

export interface BaseTextareaProps extends React.TextareaHTMLAttributes<HTMLTextAreaElement> {
  /** Whether the textarea has an error state */
  hasError?: boolean;
}

export const BaseTextarea = forwardRef<HTMLTextAreaElement, BaseTextareaProps>(
  ({ hasError, className, ...props }, ref) => {
    return (
      <textarea
        ref={ref}
        className={cn(
          'w-full rounded-lg border px-4 py-2.5 text-sm transition-all',
          'bg-gray-50 text-gray-900 placeholder-gray-400 dark:bg-[#18181b] dark:text-white dark:placeholder-zinc-500',
          'focus:outline-none focus:ring-1',
          hasError
            ? 'border-red-500 focus:border-red-500 focus:ring-red-500'
            : 'border-gray-300 focus:border-blue-500 focus:ring-blue-500 dark:border-white/[0.06]',
          props.disabled && 'cursor-not-allowed opacity-50',
          className
        )}
        {...props}
      />
    );
  }
);

BaseTextarea.displayName = 'BaseTextarea';
